import React, {FC} from 'react';
import {ObjectId} from 'types/object-id';
import {useGetProjectAttachmentsQuery} from 'features/studio/projects/store/get-project-attachments';
import {getProjectImages} from './get-project-images';

interface Props {
  projectId: ObjectId;
  fallbackTitle: string;
}

const RowImages: FC<Props> = ({projectId, fallbackTitle}) => {
  const {data, isLoading} = useGetProjectAttachmentsQuery({id: projectId});
  const images = getProjectImages(data?.data);

  if (isLoading) {
    return (
      <div className="reorder-row__images">
        {Array.from({length: 4}).map((_, i) => (
          <div key={i} className="reorder-row__thumb-loading" />
        ))}
      </div>
    );
  }

  if (images.length === 0) {
    return (
      <div className="reorder-row__images">
        <div className="reorder-row__placeholder">
          {fallbackTitle?.[0]?.toUpperCase() || '?'}
        </div>
      </div>
    );
  }

  return (
    <div className="reorder-row__images">
      {images.map(img => (
        <img
          key={String(img.id)}
          src={img.original}
          alt={fallbackTitle}
          loading="lazy"
        />
      ))}
    </div>
  );
};

export default RowImages;
